/**
 * Redirecionamentos das rotas da v1/v2-completa para a v2 enxuta (D22, 2026-09-04).
 * Client-side (<Navigate replace>) — cobre links antigos em favoritos e resultados de busca até o Amplify receber as regras 301
 * de infra/amplify-redirects.json no dia da tag v2.0.0 (as customRules são de APP e afetariam a produção v1.1.0 se aplicadas antes).
 * Chave = rota antiga; valor = destino. Prefixos terminados em "/*" cobrem qualquer filho.
 */
export const REDIRECTS: Record<string, string> = {
  '/products/genesis': '/genesis',
  '/products/auto-care': '/auto-care',
  '/products/integrations': '/connect',
  '/products/autonomy-suite': '/',
  '/products/*': '/',
  '/services/ai-consulting': '/genesis',
  '/services/intelligent-applications': '/genesis',
  '/services/*': '/',
  '/zeta': '/brand',
}
